export default {"src":"/_next/static/media/training.492707f3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};